import { customAxios, FDV_URL, TOKEN, USERNAME, IDUSUARIO } from '../constants';
import { SEARCH_PEDIDOS, FETCH_PEDIDOS, CLEAR_PEDIDOS_BUSCAR } from './types';
import { evalAction, serverError } from '../utils/actionError';

export function searchPedidos(numPlacaVeh, numPedidoVeh, numChasis, codUbicaPedidoVeh, codSituPedido, skuSap,
  codFamiliaVeh, numFichaVtaVeh, numProfVeh, nroPag = 1,  cantidadxPag = 10) {
  const isAutomovil = codFamiliaVeh === '1';

  const config = {

    headers: {
      nroPag:nroPag,
      cantidadxPag:cantidadxPag,
      idUsuario: IDUSUARIO,
      codUsuario: USERNAME
    },
    params: {
      numPedidoVeh	,
      numChasis	,
      codUbicaPedidoVeh	,
      codSituPedido	,
      numPlacaVeh,
      skuSap: isAutomovil ? [skuSap] : [] // sku de proforma
    }
  };

  const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/${numFichaVtaVeh}/proforma/${numProfVeh}/asignados`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: SEARCH_PEDIDOS,
    payload: request,
  };
}

export function clearPedidosBuscar() {
  return {
    type: CLEAR_PEDIDOS_BUSCAR,
  };
}

export function fetchPedidos(fdvID, numProfVeh = '', numPedidoVeh = '') {

  const config = {
    headers: {
      codUsuario: USERNAME,
      token: TOKEN,
    },
    params: {
      numProfVeh,
      numPedidoVeh,
    }
  };

  const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/${fdvID}/pedidos`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_PEDIDOS,
    payload: request,
  };
}



// WEBPACK FOOTER //
// ./src/actions/Pedidos.js